import { render } from "./Label.vue?vue&type=template&id=537c6ff1&scoped=true"
const script = {}

import "./Label.vue?vue&type=style&index=0&id=537c6ff1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-537c6ff1"]])

export default __exports__